import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import Sidecart from "./components/Sidecart";

import Home from "./pages/HomePage";
import About from "./pages/AboutPage";
import Products from "./pages/ProductsPage";
import SingleProduct from "./pages/SingleProductPage";
import SingleCategorie from "./pages/SingleCategoriePage";
import Contact from "./pages/ContactPage";
import Default from "./pages/Default.js";
import Cart from "./pages/CartPage.js";
import OrderInfo from "./components/OrderPage/OrderInfo";
import AdminLogin from "./components/AdminPage/AdminLogin";
import AdminProductUpdate from "./components/AdminPage/AdminProductUpdate";
import AdminAddProduct from "./components/AdminPage/AdminAddProduct";
import HandelsbetingelserPage from "./pages/HandelsbetingelserPage";
import CookieConsent from "./components/CookiesConsent";
import PrivatlivspolitikPage from "./pages/PrivatlivspolitikPage.js";

function App() {
  return (
    <Router>
      <Navbar />
      <Sidebar />
      <Sidecart />
      <div className="page-content">
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path="/contact" exact component={Contact} />
          <Route
            path="/privatlivspolitik"
            exact
            component={PrivatlivspolitikPage}
          />
          <Route
            path="/handelsbetingelser"
            exact
            component={HandelsbetingelserPage}
          />
          <Route path="/products" exact component={Products} />
          <Route path="/products/:id" component={SingleProduct} />
          <Route
            path="/adminproductupdate/:id"
            component={AdminProductUpdate}
          />
          <Route path="/products/:categorie" component={SingleCategorie} />
          <Route path="/cart" exact component={Cart} />
          <Route path="/orderinfo" exact component={OrderInfo} />
          <Route path="/admin" exact component={AdminLogin} />
          <Route path="/adminaddproduct" exact component={AdminAddProduct} />
          <Route component={Default} />
        </Switch>
      </div>
      <CookieConsent />
      <Footer />
    </Router>
  );
}

export default App;
